// extracted by mini-css-extract-plugin
export default {"intro":"Test_intro__HUsnQ","introduction":"Test_introduction__i0eaD","firstBlock":"Test_firstBlock__U2ji8","frontend":"Test_frontend__g1Jpb","subtitle":"Test_subtitle__9lxYJ"};